import React, { useEffect, useState } from 'react';
import styles from './Form.module.css';
import cn from 'classnames';
import { useTranslation } from 'react-i18next';

import { TextInput, FileInput, Textarea, Select } from '@mantine/core';

import FileInputTemplate from '@components/FileInputTemplate';

import useAuth from '@hooks/useAuth';
import useImages from '@hooks/useImages';

const Form = ({ place, form }) => {
  const { 
    place: {
      image,
      logo,
    }
  } = place;

  const [, { fetch }] = useImages();
  const { t } = useTranslation();
  const [{ currentUser }] = useAuth();
  const [fileInput1, setFileInput1] = useState();
  const [fileInput2, setFileInput2] = useState();

  const handleChange1 = (val) => {
    setFileInput1(val)
  }

  const handleChange2 = (val) => {
    setFileInput2(val)
  }

  useEffect(() => {
    if (fileInput1) {
      form.setValues({ image: fileInput1 })
    } else {
      form.setValues({ image: undefined })
    }

    if (fileInput2) {
      form.setValues({ logo: fileInput2 })
    } else {
      form.setValues({ logo: undefined })
    }
  }, [fileInput1, fileInput2])

  const data = [
    { value: 'TRANSPORT', label: t('placeType.transport') },
    { value: 'BUS_STOP', label: t('placeType.bus_stop') },
    { value: 'OTHER', label: t('placeType.other') },
    { value: 'INDUSTRIAL', label: t('placeType.industrial') },
    { value: 'HOME', label: t('placeType.home') },
    { value: 'BEACH', label: t('placeType.beach') },
    { value: 'TRADE', label: t('placeType.trade') },
    { value: 'PARK', label: t('placeType.park') },
    { value: 'EDUCATION', label: t('placeType.education') },
    { value: 'SPORT', label: t('placeType.sport') },
    { value: 'CINEMA', label: t('placeType.cinema') },
    { value: 'THEATRE', label: t('placeType.theatre') },
    { value: 'MUSEUM', label: t('placeType.museum') },
    { value: 'OFFICE', label: t('placeType.office') },
    { value: 'HOTEL', label: t('placeType.hotel') },
    { value: 'BAR', label: t('placeType.bar') },
    { value: 'NIGHT_CLUB', label: t('placeType.night_club') },
    { value: 'RESTAURANT', label: t('placeType.restaurant') },
    { value: 'MALL', label: t('placeType.mall') },
    { value: 'AIRPORT', label: t('placeType.airport') },
    { value: 'VIP', label: t('placeType.vip') },
    { value: 'EVENT', label: t('placeType.event') },
  ];

  const fetchImage = async () => {
    if (!image) {
      return
    }

    const imageResponse = await fetch(image.id, { size: 'COMPRESSED' })

    setFileInput1(imageResponse)
  }

  const fetchLogo = async () => {
    if (!logo) {
      return;
    }
    
    const imageResponse = await fetch(logo.id, { size: 'COMPRESSED' })

    setFileInput2(imageResponse)
  }

  useEffect(() => {
    fetchImage();
    fetchLogo();

  }, [image, logo])

  return (
    <div className={styles.wrapper}>

        <div className={styles.oneLine}>
          <TextInput
            className={cn(styles.input, 'disabled')}
            disabled
            label={t('placeName.label')}
            key={form.key('placeName')}
            {...form.getInputProps('placeName')}
          />

          <TextInput
            className={cn(styles.input, 'disabled')}
            disabled
            label={t('address.label')}
            key={form.key('placeAddress')}
            {...form.getInputProps('placeAddress')}
          />
        </div>

        <div className={styles.separator} />

        <Select
          className={cn(styles.input, 'disabled')}
          disabled
          label={t('type.label')}
          data={data}
          key={form.key('type')}
          {...form.getInputProps('type')}
        />

        <div className={styles.separator} />

        <div className={styles.fileInputs}>
          <FileInput
            className={styles.fileInput}
            onChange={handleChange1}
            key={fileInput1?.lastModified}
            value={fileInput1}
            label={t('place.photo')}
            inputContainer={(children) => <FileInputTemplate error={form.errors.image} key={fileInput1} setValue={setFileInput1} childrenEl={children} />}
          />

          <FileInput
            className={styles.fileInput}
            onChange={handleChange2}
            label={t('place.logo')}
            key={fileInput2?.lastModified}
            value={fileInput2}
            inputContainer={(children) => <FileInputTemplate error={form.errors.logo} key={fileInput2} setValue={setFileInput2} childrenEl={children} />}
          />
        </div>

        <div className={styles.separator} />

        <div className={styles.oneLine}>
          <Textarea
            className={cn(styles.input)}
            label={t('description.label')}
            placeholder={t('description.placeholder')}
            key={form.key('description')}
            {...form.getInputProps('description')}
          />

          <Textarea
            className={cn(styles.input)}
            label={t('schedule.label')}
            placeholder={t('schedule.placeholder')}
            key={form.key('schedule')}
            {...form.getInputProps('schedule')}
          />
        </div>

        <div className={styles.separator} />

        <div className={styles.oneLine}>
          <Textarea
            className={cn(styles.input)}
            placeholder={t('phone.placeholder')}
            label={t('phone.label')}
            key={form.key('phone')}
            {...form.getInputProps('phone')}
          />

          <Textarea
            className={cn(styles.input)}
            placeholder={t('social.placeholder')}
            label={t('social.label')}
            key={form.key('social')}
            {...form.getInputProps('social')}
          />
        </div>

        <div className={styles.separator} />

        <div className={styles.oneLine}>
          <TextInput
            className={cn(styles.inputFull)}
            label={t('site.label')}
            placeholder={t('site.placeholder')}
            key={form.key('site')}
            {...form.getInputProps('site')}
          />
        </div>

        <div className={styles.separator} />

        <div className={styles.oneLine}>
          <TextInput
            className={cn(styles.inputFull)}
            label={t('copyright.label')}
            key={form.key('copyright')}
            placeholder={t('copyright.placeholder')}
            {...form.getInputProps('copyright')}
          />
        </div>
    </div >
  )
}

export default Form;
